import {
    DESIGN_DISAPPROVE_REASON_CHANGE_ARTWORK,
    DESIGN_DISAPPROVE_REASON_CHANGE_ORDER,
    DESIGN_DISAPPROVE_REASON_NEW_ARTWORK,
} from 'frontier-constants';

export function getDisapproveReasons(isReorder){
    let options = []

    if (isReorder) {
        options = [
            {
                id: DESIGN_DISAPPROVE_REASON_CHANGE_ARTWORK,
                label: 'I have an artwork request/concern'
            },
            {
                id: DESIGN_DISAPPROVE_REASON_CHANGE_ORDER,
                label: 'I need to make a change to my order'
            }
        ];
    } else {
        options = [
            {
                id: DESIGN_DISAPPROVE_REASON_NEW_ARTWORK,
                label: 'I need to submit a new artwork file'
            },
            {
                id: DESIGN_DISAPPROVE_REASON_CHANGE_ARTWORK,
                label: 'I have an artwork request/concern'
            },
            {
                id: DESIGN_DISAPPROVE_REASON_CHANGE_ORDER,
                label: 'I need to make a change to my order'
            }
        ];
    }

    return options
}
